import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Qué datos recopilamos",
    body: "Únicamente los datos que nos entregas voluntariamente a través de los formularios del sitio: nombre de contacto, nombre artístico (si decides indicarlo), correo electrónico, WhatsApp (opcional), tus respuestas sobre el apoyo que necesitas y tu medio y horario preferido de contacto.",
  },
  {
    title: "Qué datos no solicitamos en esta etapa",
    body: "En la primera postulación no pedimos domicilio, documentos de identidad, datos bancarios ni fotografías íntimas. Cualquier verificación de identidad exigida por las plataformas se realiza personalmente por la creadora en una etapa posterior, dentro de los sistemas oficiales de cada plataforma.",
  },
  {
    title: "Para qué usamos tus datos",
    body: "Usamos la información exclusivamente para responder tus consultas, evaluar tu postulación y coordinar la reunión informativa que solicitas. No vendemos ni compartimos tus datos con terceros ajenos a la operación del sitio.",
  },
  {
    title: "Privacidad de imagen en los proyectos",
    body: "Cuando se formaliza un proyecto, la creadora puede acordar el uso de un nombre artístico, definir si muestra rostro o voz, mantener separadas sus redes personales, definir países a bloquear donde la plataforma ofrezca esa función, autorizar los canales y usos de promoción y solicitar el retiro de contenido. Un seudónimo o bloqueo geográfico no garantiza anonimato ni impide capturas o redistribución.",
  },
  {
    title: "Tus derechos",
    body: "Puedes solicitar el acceso, la rectificación o la eliminación de tus datos personales en cualquier momento a través de la página de contacto. Las postulaciones que no avanzan se eliminan una vez concluido el proceso informativo.",
  },
  {
    title: "Mayores de 18 años",
    body: "Este sitio y los servicios de Exclusive Society están dirigidos exclusivamente a personas mayores de 18 años. No recopilamos a sabiendas datos de menores de edad.",
  },
];

export default function Privacidad() {
  return (
    <div data-testid="privacidad-page">
      <section className="py-20 lg:py-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-8">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-mauve font-sans font-semibold">Legal</span>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink mt-4 leading-[1.1]">
              Política de privacidad.
            </h1>
            <p className="mt-8 text-base font-light text-stone2 leading-relaxed">
              En Exclusive Society la confidencialidad es parte central de nuestro trabajo. Esta política explica
              qué datos recopilamos en este sitio y cómo los tratamos.
            </p>
          </Reveal>
          <div className="mt-14 space-y-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.05}>
                <section data-testid={`privacidad-section-${i + 1}`} className="border-l-2 border-champagne pl-6">
                  <h2 className="font-serif text-2xl text-ink">{s.title}</h2>
                  <p className="mt-3 text-base font-light text-stone2 leading-relaxed">{s.body}</p>
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
